export default __webpack_public_path__ + "static/media/car.fcf058a1.png";